<template>
  <div style="margin-top:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Smart Driver Manager</span><br/>
      <span style="font-style: italic; font-size: 18px">Manage driver attributes and preferences used by Smart Dispatch Tools.</span>
    </div>

    <div v-if="items" class="row" style="margin: 30px 10px 30px 10px; font-weight: bold; font-size: 22px; background-color: white">
      <div class="col" style="border: 1px solid grey;">{{items.length}} of {{items_full.length}}</div>
      <div class="col" style="border: 1px solid grey;">Driver Type: <b-form-select v-model="driver_type_filter" :options="driverTypeOptions" style="font-size: 18px; font-weight: bold; width:200px"/></div>
      <div style="display: flex; align-items: center; justify-content: center;"><b-button size="md" variant="success" :disabled="loading" @click="download">Download</b-button></div>
    </div>

    <div style="margin:20px">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="name" slot-scope="row">
          <router-link :to="{ path: 'driver_detail?id=' + row.item.eld_driver_id}">{{row.item.name}}</router-link>
        </template>

        <template slot="driver_type" slot-scope="row">
          {{getOptionText(driverTypeOptions, row.item.driver_type)}}
        </template>

        <template slot="hos_distance_miles" slot-scope="row">
          {{row.item.hos_distance_miles}} | {{row.item.hos_distance_miles_7}} | {{row.item.hos_distance_miles_30}}
        </template>

<!--        <template slot="safety_score" slot-scope="row">-->
<!--          {{row.item.safety_score}} | {{row.item.safety_score_7}} | {{row.item.safety_score_30}}-->
<!--        </template>-->

<!--        <template slot="safety_score_rank" slot-scope="row">-->
<!--          {{row.item.safety_score_rank}} | {{row.item.safety_score_rank_7}} | {{row.item.safety_score_rank_30}}-->
<!--        </template>-->

        <template slot="tags" slot-scope="row">
          <span v-for="tag in row.item.tags">
            {{tag}}&nbsp;
          </span>
        </template>

      </b-table>
    <b-row>
      <b-col>
        <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            align="center"
        >
        </b-pagination>
      </b-col>
    </b-row>
    </div>

  </div>
</template>

<script>

import {get_manage_drivers_list} from '../networking/apis'
    import {mapState} from "vuex";
    import moment from "moment/moment";
    import axios from 'axios';
    import {justDate} from "@/helpers/dates";

    export default {
      name: 'driver_list',
      components: {
      },

      data() {
        return {
          toggle: {},
          file: null,
          items: [],
          items_full: [],
          selected_status: null,
          summary: [],
          type_options: [],
          vehicle_type_options: [],
          driver_type_filter: '',
          tag_filter: '',
          vehicle_type_filter: '',
          loading: true,
          totalRows: 1,
          currentPage: 1,
          perPage: 400,
          pages: [],
          fields: [
            { key: 'name', label: 'Name', sortable: true},
            { key: 'driver_type', label: 'Driver Type', sortable: true},
            { key: 'seniority_level', label: 'Seniority', sortable: true},
            { key: 'safety_score_rank_30', label:'Safety Rank', sortable: true},
            { key: 'late_nights', label: 'Late Nights?', sortable: true},
            { key: 'multiday', label: 'Multiday?', sortable: true},
            { key: 'holidays', label: 'Holidays?', sortable: true},
            { key: 'max_days_per_week', label: 'Max Days?', sortable: true},
            { key: 'charters', label: 'Charters?', sortable: true},
            { key: 'contracts', label: 'Line Runs?', sortable: true},
            { key: 'customers_to_avoid', label: 'Customers to Avoid', sortable: true},
            { key: 'preferred_customers', label: 'Preferred Customers', sortable: true},
          ],
          driverTypeOptions: [
            { value: '', text: 'All' },
            { value: 'full-time', text: 'Full Time' },
            { value: 'part-time', text: 'Part Time' },
            { value: 'casual', text: 'Casual' },
            { value: 'non-driver', text: 'Non Driver' },
          ],
        }
      },

      async created() {
        await this.load_data()
      },
      methods: {
        getOptionText(options, value) {
          const option = options.find(opt => String(opt.value) === String(value))
          return option ? option.text : value
        },
        toggle_div(item,field) {
          item[field] = !item[field];
          this.$forceUpdate();
        },
        async load_data() {
          this.loading = true
          try {
            const {value: { data = [] } } = await get_manage_drivers_list(this.user.tenant)
            this.summary = data.summary
            this.vehicle_type_options = data.summary.vehicle_type_options
            moment.tz.setDefault(this.summary.timezone)
            this.items = data.results
            this.items_full = data.results
          } catch(e) {
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }

          this.loading = false
        },
        filter_results() {
          this.items = this.items_full
          if (this.driver_type_filter != '')
            this.items = this.items.filter(item => (item.driver_type && item.driver_type == this.driver_type_filter))
        },
        async download(){
          this.$emit('showAlert', 'processing download request', 'info', 5000)
          axios.defaults.headers.common.Accept = {}
          axios.post(
              `${tbn_api_url}tbn/drivers/manage/list/download`,
              {
                tenant: this.user.tenant,
                driver_type_filter: this.driver_type_filter,
              }, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                  Accept: 'text/csv'
                },
                responseType: 'blob'
              }
          ).then((response) => {
            axios.defaults.headers.common.Accept = 'application/json'
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            const now = justDate(moment())
            // Extract just the tenant name part (before the ID suffix like "759g468f")
            // If tenant is "anderson-759g468f", we want just "anderson"
            const tenant_name = this.user.tenant.split('-').length > 1 ? this.user.tenant.split('-')[0] : this.user.tenant
            link.setAttribute(
                'download',
                `drivers-${tenant_name}-${now}.csv`
            )
            document.body.appendChild(link)
            link.click()
            this.$emit('showAlert', 'download complete', 'success', 5000)
          }).catch(e => {
            axios.defaults.headers.common.Accept = 'application/json'
            this.$emit('showAlert', 'driver data could not be downloaded.', 'danger')
          })
        }
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.load_data()
          }
        },
        driver_type_filter() {
          this.filter_results()
        },
        vehicle_type_filter() {
          this.filter_results()
        },
        tag_filter() {
          this.filter_results()
        },
      }
    }
</script>

<style>

  .col { border-radius: 5px; padding:3px}

  div.row:nth-child(even) {
    background-color: white !important;
  }
</style>

